export default "__VITE_ASSET__f$_5FvhUJDgtNju7Qh$rhg__"